import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import CardTemplate from "../CardTemplate";
import FilterTemplate from "../FilterTemplate";
import viewBookInfo from "../BookModule.module.css";
import styles from "./ViewBook.module.css";
import Pagination from "../../../../ReusuableComponent/Pagination/Pagination";
import { useLocation, useNavigate, useNavigationType } from "react-router-dom";
import { AxiosInstance } from "../../../../../axios";
import Loader from "../../../Loader";
import toast from "react-hot-toast";
import moment from "moment";
import { R_PER_PAGE } from "../../../../../labels";
import { CartContext } from "../../../../../context/CartItems";
import { WishListContext } from "../../../../../context/WishListItems";
import { debounce } from "@mui/material";
import { customStyles } from "../../../../../pages/customStyles";
import Select, { components } from "react-select";
import { CurtainsRounded } from "@mui/icons-material";

export default function ViewAllBookPage() {
  const navigate = useNavigate();
  let page = R_PER_PAGE;
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("UserId Not available");
  }
  const location = useLocation();
  const {
    categoryId,
    category_name,
    medium_name,
    mediumId,
    course_name,
    search,
    courseId,
    series_value,
    series_name,
    SELECTEDTAGS,
  } = location.state || {};

  const [isLoading, setIsLoading] = useState(false);
  const [listData, setListData] = useState([]);
  const [updateChipData, setUpdateChipData] = useState([]);

  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState(search ? search : "");
  const [searchTermCourse, setsearchTermCourse] = useState("");
  const [searchTermSubject, setsearchTermSubject] = useState("");

  const [category_on, setCategory_on] = useState([]);
  const [series_on, setSeries_Oon] = useState([]);
  const [course_on, setCourse_on] = useState([]);
  const [selectedCourseFullValue, setSelectedCourseFullValue] = useState(null);
  const [medium_on, setMedium_on] = useState([]);
  const [book_on, setBook_on] = useState([]);

  const [subject_on, setSubject_on] = useState([]);

  const [selectedTag, setSelectedTag] = useState("");

  const handleViewFilter = (id, tagName) => {
    setSelectedTag(id);
    setSeries_Oon([{ id: id, name: tagName, type: "series_on" }]);
  };

  const [selectedTags, setSelectedTags] = useState([]);

  const handleTagsFilter = (id, tagName) => {
    setSelectedTags([{ id: id, name: tagName, type: "selectedTags" }]);
  };

  let filterSearch = searchTerm
    ? [{ name: "" + searchTerm, type: "search" }]
    : [];
  const [popu_on, setPopu_on] = useState([]);

  useEffect(() => {
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
      setSearchTerm(searchTerm);
    } else {
      filterSearch = [];
      setSearchTerm("");
    }
  }, [searchTerm]);

  useEffect(() => {
    getCateList();
    if (SELECTEDTAGS && SELECTEDTAGS.length > 0) {
      setSelectedTags(SELECTEDTAGS);
    }
    if (categoryId && category_name) {
      setCategory_on([
        { id: categoryId, name: category_name, type: "category" },
      ]);
    }
    if (series_value || series_name) {
      setSeries_Oon([
        { id: series_value, name: series_name, type: "series_on" },
      ]);
    }
    if (mediumId && medium_name) {
      setMedium_on([
        { id: mediumId, name: medium_name, type: "medium_section" },
      ]);
    }
    if (courseId && course_name) {
      setCourse_on([
        { id: courseId, name: course_name, type: "course_section" },
      ]);
    }
    if (search) {
      filterSearch = [{ name: "" + search, type: "search" }];
      setSearchTerm(search);
    }
  }, []);

  useEffect(() => {
    if (updateChipData.length > 0) {
      loadListdata();
    }
  }, [updateChipData]);

  useEffect(() => {
    updateStateData();
  }, [
    category_on,
    course_on,
    medium_on,
    book_on,
    subject_on,
    popu_on,
    series_on,
    searchTerm,
    selectedTags,
  ]);

  const navType = useNavigationType();
  const containerRef = useRef(null);

  useEffect(() => {
    // scroll to top when opening the page normally
    window.scrollTo(0, 0);

    const handleRefresh = () => {
      console.log("refreshPage event triggered");
      window.scrollTo(0, 0);
    };

    // listen to any custom refresh event
    window.addEventListener("refreshPage", handleRefresh);

    return () => {
      window.removeEventListener("refreshPage", handleRefresh);
    };
  }, []); // EMPTY array = only on first screen load

  const loadListdata = (formCart = false) => {
    setListData([]);
    setIsLoading(true);
    let tempCate = category_on.map((obj) => Number(obj.id));
    let tempCourse = course_on.map((obj) => Number(obj.id));
    let tempMedium = medium_on.map((obj) => Number(obj.id));
    let tempSubj = subject_on.map((obj) => Number(obj.id));
    let tempBook = book_on.map((obj) => Number(obj.id));
    let tempPopu = popu_on.map((obj) => Number(obj.id));
    let tempseries = series_on.map((obj) => Number(obj.id));
    // let tempTags = selectedTags.length > 0 ? selectedTags : []?.map((obj) => Number(obj.id));

    let tagId = selectedTags?.length > 0 ? selectedTags[0].id : "";

    let isEb = {
      is_set: "",
      is_combo_offer: "",
      is_ebook: "",
    };
    // debugger;
    if (tempBook.includes(0)) {
      isEb = {
        is_set: 0,
        is_combo_offer: "",
        is_ebook: "",
      };
    } else if (tempBook.includes(1)) {
      isEb = {
        is_set: 1,
        is_combo_offer: "",
        is_ebook: "",
      };
    } else if (tempBook.includes(2)) {
      isEb = {
        is_set: 0,
        is_combo_offer: "",
        is_ebook: 1,
      };
    } else if (tempBook.includes(3)) {
      isEb = {
        is_set: 1,
        is_combo_offer: 1,
        is_ebook: "",
      };
    }

    AxiosInstance.post("/api/book/view_all_books", {
      search: searchTerm.length > 0 ? searchTerm : "",
      category_id:
        category_on.length > 0 ? category_on.map((cat) => cat.name) : "",
      group_course_id:
        course_on.length > 0 ? course_on.map((course) => course.name) : "",
      subject_id:
        subject_on.length > 0 ? subject_on.map((sub) => sub.name) : "",
      medium:
        medium_on.length > 0
          ? medium_on.map((med) => med.name.split(" ")[0])
          : "",
      book_type: series_on.length > 0 ? series_on.map((type) => type.name) : "",
      popularity: popu_on.length > 0 ? tempPopu[0] : 0,
      view_all_book: 1,
      user_id: userid,
      tag_id: tagId || "",
      book_id: "",
      ...isEb,
      // is_set: "",
      // is_combo_offer: "",
      // is_ebook:"",
    })
      .then((res) => {
        if (res.data.status) {
          if (!formCart) {
            setCurrentPage(1);
          }
          setListData(res?.data.data);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const [isOpen, setIsOpen] = useState({
    category: false,
    course: false,
    Medium: false,
    book_selection: false,
    book_tags: false,
    Subject: false,
  });

  const [ccategory, setCcategory] = useState([]);
  const [ccourse, setCcourse] = useState([]);
  const [originalCcourse, setOriginalCcourse] = useState([]);
  const [ssubject, setSsubject] = useState([]);
  const [originlSubject, setOriginalSubject] = useState([]);
  // Toggle the accordion open/close
  const toggleAccordion = (namesss) => {
    if (namesss === "Category") {
      setIsOpen((prevState) => ({
        category: !prevState.category,
        course: prevState.course,
        Medium: prevState.Medium,
        book_selection: prevState.book_selection,
        book_tags: prevState.book_tags,
        Subject: prevState.Subject,
      }));
    } else if (namesss === "Course") {
      setIsOpen((prevState) => ({
        category: prevState.category,
        course: !prevState.course,
        Medium: prevState.Medium,
        book_selection: prevState.book_selection,
        book_tags: prevState.book_tags,
        Subject: prevState.Subject,
      }));
    } else if (namesss === "Medium") {
      setIsOpen((prevState) => ({
        category: prevState.category,
        course: prevState.course,
        Medium: !prevState.Medium,
        book_selection: prevState.book_selection,
        book_tags: prevState.book_tags,
        Subject: prevState.Subject,
      }));
    } else if (namesss === "book_selection") {
      setIsOpen((prevState) => ({
        category: prevState.category,
        course: prevState.course,
        Medium: prevState.Medium,
        book_selection: !prevState.book_selection,
        book_tags: prevState.book_tags,
        Subject: prevState.Subject,
      }));
    } else if (namesss === "book_tags") {
      setIsOpen((prevState) => ({
        category: prevState.category,
        course: prevState.course,
        Medium: prevState.Medium,
        book_selection: prevState.book_selection,
        book_tags: !prevState.book_tags,
        Subject: prevState.Subject,
      }));
    } else if (namesss === "Subject") {
      setIsOpen((prevState) => ({
        category: prevState.category,
        course: prevState.course,
        Medium: prevState.Medium,
        book_selection: prevState.book_selection,
        book_tags: prevState.book_tags,
        Subject: !prevState.Subject,
      }));
    }
  };
  const handleSearch = (event, names) => {
    if (names == "course_section") {
      setsearchTermCourse(event.target.value);
    } else if (names == "subject_section") {
      setsearchTermSubject(event.target.value);
    }
  };

  const handleTagSelection = (tagId, tagName) => {
    if (series_value || selectedTag !== tagId) {
      setSelectedTag(tagId);
      handleViewFilter(tagId, tagName);
    } else {
      // If clicking the already selected tag, you can reset it (optional)
      setSelectedTag("");
      handleViewFilter(null, "");
    }
  };
  useEffect(() => {
    if (searchTermCourse !== "") {
      const filtered =
        originalCcourse?.length > 0 &&
        originalCcourse.filter((item) =>
          item.label?.toLowerCase().includes(searchTermCourse.toLowerCase())
        );
      setCcourse(filtered);
    } else {
      setCcourse(originalCcourse);
    }
    if (searchTermSubject !== "") {
      const filtered =
        originlSubject?.length > 0 &&
        originlSubject.filter((item) =>
          item.label?.toLowerCase().includes(searchTermSubject.toLowerCase())
        );
      setSsubject(filtered);
    } else {
      setSsubject(originlSubject);
    }
  }, [searchTermCourse, originalCcourse, searchTermSubject, originlSubject]);
  useEffect(() => {
    setSelectedTag(series_value);
  }, series_value);

  const handlechange = (e, names, selectedData) => {
    const { name, value, checked, id } = e.target;
    if (names == "category_section") {
      const newCategory = { id: value, name: name, type: "category" };
      setCategory_on([newCategory]); // Update state
    } else if (names == "book_section") {
      const newBook = { id: value, name: name, type: "book_section" };
      setBook_on([newBook]); // Update state
    } else if (names == "medium_section") {
      const newmedium = { id: value, name: name, type: "medium_section" };
      setMedium_on([newmedium]); // Update state
    } else if (names == "course_section") {
      if (checked) {
        setSelectedCourseFullValue(selectedData);
        // Add the new value to the existing course_on array
        setCourse_on((prev) => [
          ...prev,
          { id: value, name: name, type: "course_section" },
        ]);
      } else {
        // Remove the unchecked value from the course_on array
        setCourse_on((prev) => prev.filter((item) => item.id !== value));
      }
    } else if (names == "subject_section") {
      if (checked) {
        setSubject_on((prev) => [
          ...prev,
          { id: value, name: name, type: "subject_section" },
        ]);
      } else {
        setSubject_on((prev) => prev.filter((item) => item.id !== value));
      }
    } else if (names == "popup_section") {
      setPopu_on([{ id: value, name: name, type: "popup_section" }]);
    }
  };

  const handlechange_popup = (option) => {
    if (option) {
      setPopu_on([
        { id: option.value, name: option.label, type: "popup_section" },
      ]);
    } else {
      setPopu_on([]);
    }
  };
  function updateStateData() {
    let tempArr = [{}];
    filterSearch.map((obj) => {
      tempArr.push(obj);
    });
    category_on.map((obj) => {
      tempArr.push(obj);
    });
    book_on.map((obj) => {
      tempArr.push(obj);
    });
    medium_on.map((obj) => {
      tempArr.push(obj);
    });
    course_on.map((obj) => {
      tempArr.push(obj);
    });
    subject_on.map((obj) => {
      tempArr.push(obj);
    });
    if (Array.isArray(selectedTags)) {
      selectedTags.map((obj) => {
        tempArr.push(obj);
      });
    }

    // popu_on.map((obj) => {
    //   tempArr.push(obj);
    // });

    if (series_on.length > 0) {
      series_on.map((obj) => {
        tempArr.push(obj);
      });
    }

    setUpdateChipData(tempArr);
  }

  const getCateList = () => {
    AxiosInstance.get("api/course/category_list")
      .then((res) => {
        const ccategorys = res.data?.data?.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setCcategory(ccategorys);
      })
      .catch((error) => {
        return error;
      });
  };

  useEffect(() => {
    if (category_on.length > 0) {
      getCourseList();
    }
  }, [category_on]);

  //
  const getCourseList = () => {
    AxiosInstance.get(`api/all/getCourses/${category_on[0].name}/0`)
      .then((res) => {
        const ccourse_ss = res.data?.data?.map((item) => ({
          ...item,
          value: item.id,
          label: item.course_name,
        }));
        setCcourse(ccourse_ss);
        setOriginalCcourse(ccourse_ss);
      })
      .catch((error) => {
        console.error("Error fetching course list:", error);
      });
  };

  useEffect(() => {
    if (category_on.length > 0 && course_on.length > 0) {
      AxiosInstance.post("api/all/getSubjects", {
        category: selectedCourseFullValue?.category_code,
        course_name: selectedCourseFullValue?.course_name,
        sub_category: selectedCourseFullValue?.subcategory_code,
        type: 0,
      })
        .then((res) => {
          const subjui = res.data?.data?.map((item) => ({
            value: item.id,
            label: item.subject,
          }));
          setSsubject(subjui);
          setOriginalSubject(subjui);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [selectedCourseFullValue]);

  // total table data  with pages
  const totalPages = Math.ceil(listData?.length / rowsPerPage);
  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };
  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
    loadListdata();
  };
  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const { cartNotify } = useContext(CartContext);
  const { WishNotify } = useContext(WishListContext);
  // const currentData = csvListData.slice(start, end);
  const currentData = listData?.slice(start, end);
  const Tagsitems = [
    {
      tag_id: 0,
      tag_name: "A",
    },
    {
      tag_id: 1,
      tag_name: "B",
    },
    {
      tag_id: 2,
      tag_name: "GB",
    },
    {
      tag_id: 3,
      tag_name: "QB",
    },
    {
      tag_id: 4,
      tag_name: "PYQ",
    },
  ];

  const handleAddCart = (bookIds) => {
    AxiosInstance.post("/api/book/cart/add", {
      id: "",
      user_id: userid,
      book_id: bookIds,
      created_dt: moment().format("YYYY-MM-DD"),
      created_by: userid,
    })
      .then((res) => {
        if (res.data.status) {
          toast.success(res.data.message);
          // updateStateData();
          loadListdata(true);
          cartNotify(userid);
        } else {
          toast.error(res.data.message);
          sessionStorage.clear();
          navigate("/login");
        }
      })
      .catch((error) => {
        return error;
      });
  };

  const addWishList = (idsBook, is_fav) => {
    AxiosInstance.post("api/book/wishlist/add", {
      user_id: userid,
      book_id: idsBook,
      is_favorite: is_fav == 1 ? 0 : 1,
      created_dt: moment().format("YYYY-MM-DD"),
      created_by: userid,
    })
      .then((res) => {
        if (res.data.status) {
          toast.success(res.data.message);
          updateStateData();
          WishNotify(userid);
        } else {
          toast.error(res.data.message);
          sessionStorage.clear();
          navigate("/login");
        }
      })
      .catch((error) => {
        return error;
      });
  };

  const handleDelete = (datas) => {
    if (datas.type == "category") {
      const updatedCategory = category_on.filter(
        (item) => item.id !== datas.id
      );
      setCategory_on(updatedCategory);
    } else if (datas.type == "course_section") {
      const updatedcou = course_on.filter((item) => item.id !== datas.id);
      setCourse_on(updatedcou);
    } else if (datas.type == "medium_section") {
      const updatedMed = medium_on.filter((item) => item.id !== datas.id);
      setMedium_on(updatedMed);
    } else if (datas.type == "book_section") {
      const updatedbook = book_on.filter((item) => item.id !== datas.id);
      setBook_on(updatedbook);
    } else if (datas.type == "subject_section") {
      const updatedSub = subject_on.filter((item) => item.id !== datas.id);
      setSubject_on(updatedSub);
    } else if (datas.type == "series_on") {
      const updatedSeries = series_on.filter((item) => item.id !== datas.id);
      setSeries_Oon(updatedSeries);
      setSelectedTag(updatedSeries.length === 0 ? "" : updatedSeries);
    } else if (datas.type === "search") {
      setSearchTerm("");
      filterSearch = [];
    } else if (datas.type === "selectedTags") {
      const updatedTags = selectedTags.filter((item) => item.id !== datas.id);
      setSelectedTags(updatedTags);
    }
    updateStateData();
    navigate(location.pathname, { replace: true, state: {} });
  };

  const handleClearAllFilter = () => {
    setCategory_on([]);
    setCourse_on([]);
    setSubject_on([]);
    setMedium_on([]);
    setSearchTerm("");
    filterSearch = [];
    setBook_on([]);
    setSeries_Oon([]);
    setSelectedTags([]);
    navigate(location.pathname, { replace: true, state: {} });
    updateStateData();
  };

  const [poPularity, setPoPularity] = useState([
    {
      value: "1",
      label: "Ratings : High to Low",
    },
    {
      value: "2",
      label: "Ratings : Low to High",
    },
    {
      value: "6",
      label: "Bestsellers : High to Low",
    },
    {
      value: "4",
      label: "Price : High to Low",
    },
    {
      value: "5",
      label: "Price : Low to High",
    },
  ]);
  const isMobile = window.innerWidth <= 768;
  console.log(isMobile, "isMobileisMobile");

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div ref={containerRef} className="BathHeader global_container">
      <div className={`row ${viewBookInfo.padding_20_0} mx-0`}>
        <div className="col-xl-12 col-lg-12 col-md-12 col-12 col-sm-12 px-0">
          <div className={`${viewBookInfo.padding_0_10} row`}>
            <div className="px-0 col-xl-3 col-lg-3 col-md-12 col-12 col-sm-12 d-flex  align-items-end">
              <h5
                className={`px-0 ${viewBookInfo.TitleLabel} ${viewBookInfo.padding_0_10} mb-0`}
              >
                View All Books
              </h5>
            </div>
            <div
              className={`col-xl-9 col-lg-9 col-md-12 col-12 col-sm-12 d-flex  justify-content-between align-items-end ${viewBookInfo.pagination_filtersec} cursorPnt`}
            >
              <p className={`${viewBookInfo.paginationLabel} mb-0`}>
                (Showing{" "}
                {listData && listData?.length > 0
                  ? currentPage * rowsPerPage + 1 - rowsPerPage
                  : 0}
                –
                {listData && listData?.length > 0
                  ? listData?.length < currentPage * rowsPerPage
                    ? listData?.length
                    : currentPage * rowsPerPage
                  : 0}{" "}
                books of{" "}
                {listData && listData?.length > 0 ? listData?.length : 0} books)
              </p>

              <Select
                className={`shadow-none input-font-size `}
                name="popup_section"
                isClearable={true}
                onChange={(option) =>
                  handlechange_popup(option, "popup_section")
                }
                value={popu_on.map((value) => ({
                  value: value.id,
                  label: value.name,
                }))}
                options={poPularity}
                isSearchable={true} // Enables search functionality
                placeholder="Sort by"
                maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
                filterOption={(option, searchText) =>
                  option.label.toLowerCase().includes(searchText.toLowerCase())
                } // Filter options based on the search text
                styles={{
                  ...customStyles,
                  container: (base) => ({
                    ...base,
                    width: isMobile ? "100%" : "25%",
                  }),
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className={`row mx-0  pb-4`}>
        <div className="col-xl-3 col-lg-3  col-md-3  col-12 col-sm-12 px-0 cursorPnt">
          <FilterTemplate
            toggleAccordion={toggleAccordion}
            isOpen={isOpen}
            ccategory={ccategory}
            ccourse={ccourse}
            ssubject={ssubject}
            category_on={category_on}
            course_on={course_on}
            subject_on={subject_on}
            medium_on={medium_on}
            book_on={book_on}
            handleSearch={handleSearch}
            searchTermCourse={searchTermCourse}
            searchTermSubject={searchTermSubject}
            handlechange={handlechange}
            updateChipData={updateChipData}
            handleClearAllFilter={handleClearAllFilter}
            handleDelete={handleDelete}
            Tagsitems={Tagsitems}
            selectedTag={series_on.length > 0 ? series_on[0].id : selectedTag}
            handleTagSelection={handleTagSelection}
            handleViewFilter={handleViewFilter}
          />
        </div>
        <div className={`col-xl-9 col-lg-9   col-md-9  col-12 col-sm-12`}>
          <div className={`row  ${viewBookInfo.BookborderRed} mx-0`}>
            {currentData.length > 0 ? (
              currentData.map((iop) => (
                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-2">
                  <CardTemplate
                    items={iop}
                    toggleWish={addWishList}
                    handleSubmitCart={handleAddCart}
                    tagsFilter={selectedTags}
                    handleTagsFilter={handleTagsFilter}
                    isSet={0}
                  />
                </div>
              ))
            ) : (
              <p className="st_confirm_label ms-1 text-center mt-4 mb-4 ">
                No records to display
              </p>
            )}
          </div>

          <div className="row mx-0">
            <div
              className={`col-md-12 ${viewBookInfo.paginationSection} ${viewBookInfo.BookborderRed}`}
            >
              <Pagination
                mediumSize={"offset-md-5 col-md-7 "}
                Isbook={true}
                rowsPerPage={rowsPerPage}
                handlePageCount={handlePageCount}
                startPage={
                  listData && listData?.length > 0
                    ? currentPage * rowsPerPage + 1 - rowsPerPage
                    : 0
                }
                endPage={
                  listData && listData?.length > 0
                    ? listData?.length < currentPage * rowsPerPage
                      ? listData?.length
                      : currentPage * rowsPerPage
                    : 0
                }
                totalRecords={
                  listData && listData?.length > 0 ? listData?.length : 0
                }
                handlePrev={(e) => handlePrev(currentPage - 1)}
                currentPrevPage={currentPage === 1}
                prevButton={`${viewBookInfo.prev_buttonViewAllbook} ${viewBookInfo.materialIconsRightAndLeft} me-2`}
                handleNext={() => handleNext(currentPage + 1)}
                currentNextPage={currentPage === totalPages || totalPages === 0}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
